import { AbstractControl, FormGroup, ValidationErrors } from '@angular/forms';
const INVALID_EMAILS_ENDS = ['@yopmail.com'];

export class FormsValidators {
  static markFormGroupTouched(formGroup: FormGroup) {
    Object.values(formGroup.controls).forEach((control: any) => {
      control.markAsTouched();
      if (control.controls) {
        Object.values(control.controls).forEach((c: any) => {
          c.markAsTouched();
        });
      }
    });
  }

  static validateNip(expected: string) {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;

      if (value && value !== expected) {
        return { invalidNip: true };
      }
      return null;
    };
  }

  static validateEmailEnd() {
    return (control: AbstractControl): ValidationErrors | null => {
      if (control.errors && control.errors['email']) {
        return null;
      }

      const email = control.value;

      if (!INVALID_EMAILS_ENDS.some((end) => email?.endsWith(end))) {
        return null;
      }

      return { emailEnd: true };
    };
  }

  static maxLengthPostalCode(country: string) {
    return (control: AbstractControl): ValidationErrors | null => {
      const value: string = control.value;
      if (!value) {
        return null;
      }

      if (country === 'co' && value.length === 6) {
        return null;
      }

      if (country === 'mx' && value.length === 5) {
        return null;
      }

      if (country === 'cl' && value.length === 7) {
        return null;
      }

      return { maxLength: true };
    };
  }

  static validateEmailDifferent(mailDriver: string) {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (value === mailDriver) {
        return { invalidEmail: true };
      }
      return null;
    };
  }
}
